<ng-template let-fields="fields" let-field="field" let-viewSource$="viewSource" let-modeView$="modeView" #dragAndDrop>
  <mode-encoding-field-filter
    (updateVariableType)="updateVariableType($event)"
    (updateSequence)="updateSequence($event)"
    (editFilter)="editFilter($event)"
    (remove)="removeField($event)"
    [encoding]="encoding"
    [field]="field"
    [model]="model"
    [viewName]="viewSource$"
  >
  </mode-encoding-field-filter>
</ng-template>

<div class="card-block">
  <mode-encoding-dropzone
    [header]="'Filters'"
    [channel]="'filter'"
    [isDraggable]="isDragging() && !isSystem"
    [placeholderClasses]="false"
    [fields]="encoding.filter"
    [template]="dragAndDrop"
    [viewSource]="queryToken$ | async"
    [view]="view$ | async"
    [isMetrics]="false"
    [chartType]="chartType"
    [dragField]="dragInfo"
    (dropField)="onDrop($event)"
    (dragStart)="onDragStart($event)"
    (dragEnd)="onDragEnd($event)"
    (fieldDropOnField)="onFieldDrop($event)"
  ></mode-encoding-dropzone>
</div>
